export const USERS_TAG_EVENTS = {
  CREATED_GRANTED_GROUP: 'CreatedGrantedGroup',
};

export const USERS_EVENT_LABELS = {
  CREATED_GRANTED_GROUP_WITH_GROUP_NINE: 'CreatedGrantedGroupWithGroupNine',
};
